export default "__VITE_ASSET__DdhmMsh___"